import React, { useEffect, useMemo, useState } from 'react';
import PageHeader from '../components/PageHeader';
import DataTable from '../components/DataTable';
import { customers } from '../../services/apiClient';

export default function AdminCustomers() {
  const [data, setData] = useState([]);
  const [query, setQuery] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;

    async function load() {
      setLoading(true);
      setError('');
      try {
        const list = await customers.list({ q: query || undefined });
        if (mounted) setData(list);
      } catch {
        if (mounted) setError('Erro ao carregar clientes');
      } finally {
        if (mounted) setLoading(false);
      }
    }

    load();

    return () => {
      mounted = false;
    };
  }, [query]);

  const columns = useMemo(() => [
    { key: 'name', header: 'Cliente' },
    { key: 'email', header: 'Email' },
    { key: 'orders', header: 'Pedidos' }
  ], []);

  return (
    <div className="admin-section">
      <PageHeader title="Clientes" subtitle="Base de clientes e histórico" />

      <div className="admin-filters">
        <input className="admin-input" placeholder="Buscar cliente" value={query} onChange={(e) => setQuery(e.target.value)} />
      </div>

      <DataTable columns={columns} data={data} loading={loading} error={error} emptyMessage="Nenhum cliente encontrado" />
    </div>
  );
}
